<template>
  <v-footer id="core-footer" absolute height="42" elevation="4">
    <div class="footer-items ml-12 pl-10">
      <span v-for="link in links" :key="link.name">
        <a :href="link.Link" class="tertiary--text footer-links">{{
          link.name
        }}</a>
      </span>
    </div>
    <v-spacer />
    <span class="font-weight-light copyright">
      &copy;
      {{ new Date().getFullYear() }}
      <a href="https://www.cleed.ai/" target="_blank">Cleed</a>
    </span>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    links: [{ name: "Home", Link: "/#" }],
  }),
};
</script>

<style>
#core-footer {
  position: fixed;
  z-index: 1;
}
</style>
